module.exports = __webpack_public_path__ + "static/media/BolloManjar.a6e460ab.jpg";